export const SET_BIT_SAT_TESTS_DATA = "SET_BIT_SAT_TESTS_DATA";
export const SET_BIT_SAT_TESTS_RESULT_DATA = "SET_BIT_SAT_TESTS_RESULT_DATA";

